export default __webpack_public_path__ + "static/media/livechat.e4460339.webp";